import React from 'react';
import { I18n } from 'react-redux-i18n';
import Select from 'react-select';

export default props => (
  <Select
    {...props}
    noOptionsMessage={() => I18n.t('noOptions')}
    styles={{
      ...(props.styles || {}),
      menuPortal: base => ({ ...base, zIndex: 9999 }),
    }}
  />
);
